export default {
  title: 'Modules complémentaires pour plus de succès',
  description: 'Améliorez votre offre avec des fonctionnalités supplémentaires',
  buttons: {
    continue: 'Continuer',
    no_app_for_now: "Pas d'application mobile pour l'instant",
  },
  toasts: {
    something_went_wrong: 'Une erreur est survenue, veuillez actualiser la page ou contacter le support technique !',
    failed_to_save_changes: "Impossible d'enregistrer les modifications, veuillez contacter le support technique !",
    changes_got_saved: 'Les modifications ont été enregistrées avec succès !',
  },
};
